import './App.css';
import Gallery from './components/Gallery/Gallery';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <main>
        <Gallery />
      </main>
      <Footer />
    </div>
  );
}

export default App;
